import { html } from "lit";

export const TeaserGatedContentTemplate = (args) => html`
    <ux-iws-link-wrapper
        class="ux-u-shadow ux-u-background-white ux-u-margin-top-25 ux-u-margin-bottom-25"
    >
        <div
            class="${args.shadow
                ? "ux-u-shadow"
                : ""} ux-u-p-xs ux-u-text-align--left"
        >
            <div class="ux-u-d-flex ux-u-mb-xxs">
                <ux-icon
                    name="${args.icon}"
                    size-s="${args.iconSize}"
                ></ux-icon>
                <div class="ux-u-ml-xs">
                    <h3
                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-m-zero"
                    >
                        ${args.headline}
                    </h3>
                    <h4 class="ux-text-normal ux-u-m-zero">${args.subline}</h4>
                </div>
            </div>
            <div>
                <div class="ux-text-normal">
                    <p class="ux-u-m-zero">${args.text}</p>
                </div>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;

export const TeaserGatedContent = (args) => {
    return TeaserGatedContentTemplate(args);
};
